module.exports = __webpack_public_path__ + "assets/img/main.3f2fff0a.png";